import type { NuxtApp } from '#app'
import { fetch } from '../request'
import type {
  IPageResponse,
  IPaginatedConfig,
  IResponse,
} from '../interface/common'
import type { Tag } from '../interface'

// /material/youyan_config/character_collection_page/
// 数字人集合页

export interface Body {
  skasset: string
}

export interface ClotheClothInfo {
  colors: string
  is_general: string
  secondary_colors?: string
  terminal_application: string
  component_type_en_name: string
}
export interface Param {
  name: string
  value: number[] | number
}
export interface Matconfig {
  name: string
  params: Param[]
}

export interface Clothe {
  skasset: string
  matconfig?: Matconfig[]
  cloth_info: ClotheClothInfo
  sourcebody: string
}

export interface EyeXgen {
  matdir: string
  hairasset: string
  sourcebody: string
}

export interface HairXgen {
  hairasset: string
  sourcebody: string
}

export interface ShoeClothInfo {
  colors: string
  is_general: string
  terminal_application: string
}

export interface Shoe {
  skasset: string
  cloth_info: ShoeClothInfo
}

export interface Look {
  Body: Body[]
  Shoes: Shoe[]
  Clothes: Clothe[]
  Hair_Xgen: HairXgen[]
  Eyebrow_Xgen: EyeXgen[]
  Eyelash_Xgen: EyeXgen[]
}

export interface Config {
  character_name: string
  look: Look
  look_name: string
  only_show_character_name: string
  version: string
  gender: string
}

export interface PreviewLayersJSON {
  sit0: string
  sit1: string
  sit2: string
  sit3: string
  stand1: string
}

export interface ICharacter {
  homepage_cover_url?: string
  id: number
  config_type: number
  group_id: number
  status: number
  identity: string
  config: Config
  preview_videos: string[]
  image_url: string
  name: string
  order_index: number
  oss_path: string
  create_time: Date
  update_time: Date
  tags: string[]
  tag_ids: { [key: string]: number[] }
  music_url: string
  description: string
  preview_layers_json: PreviewLayersJSON
  score: number
  resolution: string
  cover_url: string
  url: string
  group_name: string
  cover_oss_path: string
  general_type: null
  secret_id: string
  tags_admin: Tag[]
  tag_ids_admin: Tag
  online_time: null
  font_family: string
  coin: number
  recommended: boolean
  best_sta_face_id: null
  cdn_update_timestamp: number
  project_count: number
  generate_record_count: number
  is_star_personal: boolean
}

export const getCharacterCollectionPage = (
  params: {
    tag_ids?: string
    tag_id?: string
    name?: string
  } & IPaginatedConfig,
  nuxtApp?: NuxtApp
) =>
  fetch<IPageResponse<ICharacter>>(
    '/material/youyan_config/character_collection_page/',
    {
      params,
    },
    nuxtApp
  )
